import PropTypes from "prop-types";
import { useVideo } from "../../../hooks/useVideo";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { useState } from "react";
import DelFaqConfirmation from "./DelFaqConfirmation";

const AdminFaq = ({ faq, index }) => {
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const { formatDate } = useVideo();

  const handleFaqDeletion = () => {
    setConfirmationOpen(true);
  };

  if (!faq) return null; // Early return if user data is not available

  // Render user data in a row
  return (
    <>
      {confirmationOpen && (
        <DelFaqConfirmation
          faq={faq}
          setConfirmationOpen={setConfirmationOpen}
        />
      )}

      <tr>
        <td>{index + 1}.</td>
        <td>{faq.question}</td>
        <td>{parse(`${faq.answer.trim().substring(0, 100)}...`)}</td>
        <td>{formatDate(faq?.createdAt)}</td>
        <td className="table_actions">
          <button className="del-button" onClick={handleFaqDeletion}>
            Delete
          </button>
          <Link
            className="ed-button"
            aria-label={`edit ${faq.name}`}
            to={`/admin-dashboard/faqs/edit-faq/${faq?._id}`}
          >
            Edit
          </Link>
        </td>
      </tr>
    </>
  );
};

// Prop Types for type checking
AdminFaq.propTypes = {
  faq: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default AdminFaq;
